/** @format */

import store from '../../app/redux/store'
import {decodeAuthToken} from './UtilityHelper'

/*function to fetch logged is user role */
export function getRole() {
  const {roles = []} = decodeAuthToken(getToken())
  return roles
}

export function getToken() {
  const globalState = store.getState()
  const accessToken = globalState.user.userInfo.accessToken
  return accessToken
}

export function getUserName() {
  const globalState = store.getState()
  const username = globalState.user.userInfo.username
  return username
}

export function getAccess() {
  const userToken = decodeAuthToken(getToken())
  return userToken?.accessList || []
}

export function isAdmin() {
  // const roles = getRole();
  const accessList = getAccess()
  // const mergedList = [...roles, ...accessList];
  if (accessList.length > 0 && accessList.includes('MERCHANT_ADMIN')) {
    return true
  } else {
    return false
  }
}

export function isAuthorized(roles) {
  if ((roles || []).length === 0) {
    return true
  }

  if (isAdmin()) {
    return true
  }

  const accessList = getAccess()
  return roles.some((role) => accessList.includes(role))
}

export function isEmailDomainAllowed(allowedDomains) {
  if (!allowedDomains || allowedDomains.length === 0) return true
  const email = (getUserName() || '').trim().toLowerCase()
  const domain = email.split('@')[1]
  if (!domain) return false
  return allowedDomains.map((d) => d.trim().toLowerCase()).includes(domain)
}

export function getMerchant() {
  const globalState = store.getState()
  const merchant = globalState.user.userInfo.merchant
  return merchant
}
